import ResetPasswordShell from "../../components/reset-password-shell";

const ResetPasswordPage = () => {
  return (
    <div className="flex h-screen justify-center items-center">
      <ResetPasswordShell />
    </div>
  );
};

export default ResetPasswordPage;
